/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "1.5.0",
  "gitBuildTime": "2026-01-12T12:33:14.238Z",
  "gitBuildVersion": "1.5.0",
  "gitCommitId": "256a277",
  "gitCommitIdFull": "256a2772f918f16262c082965814a896cebee70d",
  "gitCommitTime": "2026-01-12T12:09:47.000Z",
  "version": "1.5.0-2026-01-12T12:09:47.000Z-(256a277)"
};
